<template>
 <!-- 其他险种管理-明细 -->
  <div>
    <div v-show="Qtxzgl_detailed">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">其他险种管理-明细</div>
        <el-button style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="Return">返回</el-button>
    <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
      <!-- 查询框 -->
      <div style="margin-left:3%">
        <div style="height:40px"></div>
        <div style="display:inline-block">
            <span>组织架构</span>
            <el-cascader v-model="condition.organize_ids" clearable
                style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
        </div>

        <div style="display:inline-block;margin-left:20px">
            <span>唯一识别码 </span>
          <el-input v-model="condition.unique_id" style="margin-left:10px;width:170px" placeholder="请输入唯一识别码"></el-input>
        </div>

        <div style="display:inline-block;margin-left:20px">
            <span>名称/品牌 </span>
            <el-input v-model="condition.brand" style="margin-left:10px;width:170px" placeholder="请输入名称/品牌"></el-input>
        </div>

        <div style="display:inline-block;margin-left:20px">
            <span>缴纳状态 </span>
            <el-select v-model="condition.spare5" style="margin-left:10px;width:170px"
                placeholder="请选择缴纳状态" clearable>
                <el-option v-for="item in jnList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>

        <div style="display:inline-block;margin-left:20px">
            <span>导表状态 </span>
            <el-select v-model="condition.spare6" style="margin-left:10px;width:170px"
                placeholder="请选择导表状态" clearable>
                <el-option v-for="item in dbList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>


        <!-- 按钮 -->
        <div style="display:inline-block;margin-top:20px">
          <el-button type="goon" @click="Find">查询</el-button>
          <el-button type="goon">导表</el-button>
          <el-button type="goon" @click="Del()">删除</el-button>
          <el-button type="goon">缴纳</el-button>
          <el-button type="goon">取消</el-button>
          <el-button type="addbtn" @click="add('ruleForm')">新增</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <div style="margin:2% 3% 0 3%">
        <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="540" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="organize_name" align="center" label="所属项目"></el-table-column>
          <el-table-column prop="unique_id" align="center" label="唯一识别码"></el-table-column>
          <el-table-column prop="insure_number" align="center"  label="投保数量"></el-table-column>
          <el-table-column prop="brand" align="center" label="名称/品牌"></el-table-column>
          <el-table-column prop="model" align="center" label="规格/型号"></el-table-column>
          <el-table-column prop="cost" align="center" label="费用金额"></el-table-column>
          <el-table-column prop="" align="center" label="缴纳状态" width=100>
            <template slot-scope="scope">
                <img src="../../../assets/stateImg/状态_未缴纳.png" v-show="scope.row.spare5 === '0'" />
                <img src="../../../assets/stateImg/状态_已缴纳.png" v-show="scope.row.spare5 === '1'" />
                <img src="../../../assets/stateImg/状态_未退保.png" v-show="scope.row.spare5 === '2'" />
                <img src="../../../assets/stateImg/状态_已退保.png" v-show="scope.row.spare5 === '3'" />
            </template>
          </el-table-column>
          <el-table-column prop="" align="center" label="导表状态" width=100>
            <template slot-scope="scope">
                <img src="../../../assets/stateImg/状态_未导表.png" v-show="scope.row.spare6 === '0'" />
                <img src="../../../assets/stateImg/状态_已导表.png" v-show="scope.row.spare6 === '1'" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="100">
            <template slot-scope="scope">
              <img src="../../../assets/编辑.png" @click="bianji(scope.row)">
              <img src="../../../assets/删除.png" @click="Del(scope.row.id)">
            </template>
          </el-table-column>

        </el-table>

        <!-- 分页 -->
					<el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
      </div>
      
    </div>
    </div>
  <add ref="adds" v-show="showadd" :organizeList="organizeList"></add>
  </div>
</template>

<script>
import axios from 'axios';
import add from './Qtxzgl_detailed_add.vue';
export default {
  components: {
    add:add,
  },
  data() {
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
			return organizeList.data;
		};
    return {
      page_num: 1,
      page_size: 10,
      total: 0,
      //删除ids
      ids: [],
      tableData:[],
      //项目下拉
      xmList: [],
      jnList: [{
          value: '0',
          label: '未缴纳'
      }, {
          value: '1',
          label: '已缴纳'
      }, {
          value: '2',
          label: '未退保'
      }, {
          value: '3',
          label: '已退保'
      }],
      dbList: [{
          value: '0',
          label: '未导表'
      }, {
          value: '1',
          label: '已导表'
      }],
      ruleForm: {
        insurance_id:'',
        insurance_name:'',
        policy_no:'',
		organize_temporary_ids:'',
          insuranceList:[{
            insurance_id:'',
            insurance_name:'',
            policy_no:'',
            insurance_name:'',
            project_id:'',
            unique_id:'',
            insure_number:'',
            brand:'',
            model:'',
            cost:'',
            start_date:'',
            end_date:'',
            payment_date:'',
            remarks:'',
            copy_url:'',
            enclosure_url:'',
        }],
        insurance:{
            insurance_id:'',
            insurance_name:'',
            policy_no:'',
            insurance_name:'',
            project_id:'',
            unique_id:'',
            insure_number:'',
            brand:'',
            model:'',
            cost:'',
            start_date:'',
            end_date:'',
            payment_date:'',
            remarks:'',
            copy_url:'',
            enclosure_url:'',
          }      
        },
      condition:{
				organize_ids: [],
        project_id:'',
        unique_id:'',
        brand:'',
        spare5:'',
        spare6:'',
      },
      // 权限
      Qtxzgl_detailed:true,

		//组织架构数据
	  organizeList: [],
	  
	  //级联下拉配置
	  props: {
			lazy: true,
			async lazyLoad(node, resolve) {
				if (node.level === 0) {
					return resolve(await organizeFind('', 'group'));
				} else {
					resolve(await organizeFind(node.data.id, ''));
				}
			},
	      value: "id",
	      label: "organize_name",
	      children: "organizeList",
	      checkStrictly: true,
	      multiple: true,
	  },
      
    }
  },
  methods: {
    // 全选
    handleSelectionChange(e) {
      this.ids = [];
      e.forEach(item => {
          this.ids.push(item.id);
      });
    },
    //分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
    //查询
    async Find() {
		var temporary = [];
		this.condition.organize_ids.forEach(item => {
		    temporary.push(item[item.length - 1]);
		})
		var organize_ids = "";
		temporary.forEach(item => {
		    organize_ids += item + ",";
		})
		
      this.ruleForm = this.$parent.ruleForm;
        var url = 'InsuranceDetailed/selectAll';
        var record = {
            page_num: this.page_num,
            page_size: this.page_size,
            insurance_id:this.ruleForm.insurance_id,
            insurance_name:this.ruleForm.insurance_name,
            policy_no:this.ruleForm.policy_no,
            organize_ids:organize_ids,
            unique_id:this.condition.unique_id,
            brand:this.condition.brand,
            spare5:this.condition.spare5,
            spare6:this.condition.spare6,
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === '-2000') {
            this.$message.error('服务器未响应！请稍后重试');
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.tableData = data.list;
                this.total = data.total;
            } else {
                this.$message.warning('请求失败！请稍后重试');
            }
        }
    },
    Return(){
        this.$parent.Return();
        this.ruleForm.insuranceList = [this.ruleForm.insurance];
    },
    // 新增
    add(){
      this.trash();
      this.Qtxzgl_detailed = false;
      this.showadd = true;

    },
    // 操作修改
    bianji(e){
      this.Qtxzgl_detailed = false;
      this.showadd = true;
      this.ruleForm.id = e.id;
	
	  var project_ids = [];
	  e.organize_ids.split(",").forEach(item => {
		  if(item != null && item != ''){
			  project_ids.push(parseInt(item))
		  }
	  })
	  
      this.ruleForm.insuranceList = [{
		  id: e.id,
        insurance_id:e.insurance_id,
        insurance_name:e.insurance_name,
        policy_no:e.policy_no,
        insurance_name:e.insurance_name,
		organize_ids: e.organize_ids,
		project_ids: project_ids,
        project_id:e.project_id,
        unique_id:e.unique_id,
        insure_number:e.insure_number,
        brand:e.brand,
        model:e.model,
        cost:e.cost,
        start_date:e.start_date,
        end_date:e.end_date,
        payment_date:e.payment_date,
        remarks:e.remarks,
        copy_url:e.copy_url,
        enclosure_url:e.enclosure_url,
      }];
      this.$refs["adds"].ruleForm = this.ruleForm;
	  this.$refs["adds"].insuranceList = this.ruleForm.insuranceList;
    },
    //删除
    Del(e) {
      var ids;
      if (e === null || e === '' || e === undefined) {
        if (this.ids === null || this.ids.length <= 0) {
          this.$message.warning('请先选择操作数据！');
          return false;
        }
        ids = this.ids;
      } else {
        ids = [e];
      }
      const url = this.$globals.http + '/InsuranceDetailed/del';
      axios
        .post(url, {
          ids: ids,
        })
        .then((response) => {
          var code = response.data.code;
          var data = response.data.data;

          if (code === '200') {
            this.$message.success(data);
            this.Find();
          } else {
            this.$message.warning('请求失败！请稍后重试');
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error('服务器未响应！请稍后重试');
        });
    },
    //清除数据
    trash() {
      this.ruleForm.id = '';
      this.ruleForm.insuranceList = '';
    },
	//初始化组织架构及下面的人
	async organizeFind() {
	    var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
	        identification: "1",
	    });
	    this.organizeList = this.getTreeData(organizeList.data);
	
	},
	getTreeData(data) {
	    // 循环遍历json数据
	    for (var i = 0; i < data.length; i++) {
	
	        if (data[i].organizeList.length < 1) {
	            // children若为空数组，则将children设为undefined
	            data[i].organizeList = undefined;
	        } else {
	            // children若不为空数组，则继续 递归调用 本方法
	            this.getTreeData(data[i].organizeList);
	        }
	    }
	    return data;
	}
  },
  created() {
    this.organizeFind();
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// Qtxzgl_detailed.vue?5c3d0b08